import React from "react";
import Layout from "../../hoc/Layout/Layout";
import DeadEnd from "../DeadEnd/DeadEnd";
import Boiler from "./Boiler/Boiler";
import classes from "./Boilers.module.css";

const Boilers = ({ boilers, goBack, backToStart }) => {
  let data = boilers.length ? (
    <React.Fragment>
      <div className={classes.heading}>Choose your boiler</div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        {boilers.map(
          ({
            name,
            price,
            url,
            centralHeatingOutput,
            guarantee,
            imagePath,
            originalPrice,
            width,
            height,
            depth,
            latestModel,
          }) => {
            return (
              <Boiler
                name={name}
                price={price}
                originalPrice={originalPrice}
                url={url}
                centralHeatingOutput={centralHeatingOutput}
                guarantee={guarantee}
                path={imagePath}
                width={width}
                height={height}
                depth={depth}
                latestModel={latestModel}
              />
            );
          }
        )}
      </div>
    </React.Fragment>
  ) : (
    <Layout goBack={goBack}>
      <DeadEnd
        heading="No available options"
        subText="Unfortunately we don't have any boilers available to suit your needs. Please give us a ring on 01344 483816 if you'd like to discuss further options."
        backToStart={backToStart}
      />
    </Layout>
  );
  return data;
};

export default Boilers;
